/**
 * Popover for shopify product variants
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import enhanceWithClickOutside from 'react-click-outside'
import * as _ from 'lodash'
import PopoverHeader from './PopoverHeader'
import { api } from '../../../api/integrationAPI'
import { setCustomFieldArray } from 'controllers/logic'
import OptionsView from './shopifyVariantsPopover/OptionsView'
import { toFirebaseKey } from 'utils/utils'
import Text from 'components/common/Text'

const Container = styled.div`
  min-height: 10em;
  width: 33em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border-radius: 8px;
  box-shadow: 0 4px 10px 8px rgba(175,175,175,0.27);

  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
`
const Content = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  overflow-y: auto;
  padding-bottom: 2em;
`

class ShopifyVariantsPopover extends Component {

  componentWillMount () {
    this.props.updatePosition('10%', '46%')
  }

  renderMessage (message) {
    return (
      <Text>{message}</Text>
    )
  }

  updateProductColor = (titleRaw, value) => {
    const title = toFirebaseKey(titleRaw)
    const { app, field, dispatch } = this.props
    const product = _.get(app.customFields, field.paths[0])
    const productCopy = _.clone(product)
    if (value === null) {
      _.unset(productCopy, ['colorOptions', title])
    } else {
      _.set(productCopy, ['colorOptions', title], value)
    }
    // console.log('productCopy', productCopy)
    dispatch(setCustomFieldArray(app.id, field.paths[0], productCopy))
  }

  renderOptions = (productInfo) => {
    // console.log('variants', variants)
    return (
      <OptionsView
        productInfo={productInfo}
        updateProductColor={this.updateProductColor}
      />
    )
  }

  renderContent () {
    const { app, field } = this.props
    const product = _.get(app.customFields, field.paths[0])
    // console.log(product)
    if (_.has(product, ['productId'])) {
      const info = api.getProductInfo(product)
      if (_.has(info, ['details', 'options'])) {
        // return this.renderOptions(info.details.options)
        return this.renderOptions(info)
      } else {
        return this.renderMessage('The product has no options')
      }
    } else {
      return this.renderMessage('The product is not configured yet')
    }
  }

  render () {
    const { title, closeMyself } = this.props
    return (
      <Container>
        <PopoverHeader
          title={title}
          onClose={closeMyself}
          helpTooltip={'Select the product from your Shopify store.'}
        />
        <Content>
          {this.renderContent()}
        </Content>
      </Container>
    )
  }
}

ShopifyVariantsPopover.propTypes = {
  closeMyself: PropTypes.func.isRequired,
  title: PropTypes.string,
  app: PropTypes.object.isRequired,
  field: PropTypes.object.isRequired,
  updatePosition: PropTypes.func,
}

export default connect()(enhanceWithClickOutside(ShopifyVariantsPopover))



// WEBPACK FOOTER //
// ./src/components/editor/popovers/ShopifyVariantsPopover.js